import script from "./PatientVisitPackagesAndMaterialsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientVisitPackagesAndMaterialsNew.vue?vue&type=script&setup=true&lang=js"

import "./PatientVisitPackagesAndMaterialsNew.vue?vue&type=style&index=0&id=3ab53230&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab53230"]])

export default __exports__